// extracted by mini-css-extract-plugin
export default {"grid":"LoadingSkeleton_grid__ffdMd"};